import { useState } from "react";
import { useCreateStripeAdminAxiosInstance } from "../../Auth/useCreateStripeAdminAxiosInstance.ts";

export type RefundInformation = {
  refundableAmount: number;
  chargeId?: string;
  paidInvoices?: number;
};

export function useGetRefundInformation() {
  const { createAxiosInstance } = useCreateStripeAdminAxiosInstance();
  const [loading, setLoading] = useState(false);

  const getRefundInformation = async (
    orderId: string,
  ): Promise<RefundInformation> => {
    const axiosInstance = createAxiosInstance();
    try {
      setLoading(true);
      const { data } = await axiosInstance.get<RefundInformation>(
        `/admin/refund/${orderId}`,
      );
      return data;
    } finally {
      setLoading(false);
    }
  };

  return {
    getRefundInformation,
    loading,
  };
}
